import { Inject, Injectable, Injector, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActiveToast, IndividualConfig, Overlay, TOAST_CONFIG, ToastrService, ToastToken } from 'ngx-toastr';

/**
 * Μέγιστο μήκος κειμένου που δείχνει το toast.
 */
export const TOAST_MAX_LENGTH = 500;

/**
 * Κόβει το κείμενο μόνο στην εμφάνιση του toast, ώστε ένα μεγάλο σφάλμα
 * να μη γεμίζει ολόκληρη την οθόνη.
 *
 * Η κοπή γίνεται εδώ και μόνο εδώ. Η κονσόλα, η καταγραφή και οτιδήποτε άλλο
 * χειρίζεται το σφάλμα συνεχίζουν να παίρνουν το πλήρες κείμενο.
 */
@Injectable()
export class TruncatedToastrService extends ToastrService {

    constructor(
        @Inject(TOAST_CONFIG) token: ToastToken,
        overlay: Overlay,
        injector: Injector,
        sanitizer: DomSanitizer,
        ngZone: NgZone) {
        super(token, overlay, injector, sanitizer, ngZone);
    }

    override show<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>, type?: string): ActiveToast<any> {
        return super.show(this.truncate(message), title, override, type);
    }

    override success<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<any> {
        return super.success(this.truncate(message), title, override);
    }

    override error<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<any> {
        return super.error(this.truncate(message), title, override);
    }

    override info<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<any> {
        return super.info(this.truncate(message), title, override);
    }

    override warning<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<any> {
        return super.warning(this.truncate(message), title, override);
    }

    /**
     * Αν το μήνυμα είναι HTML (enableHtml) και η κοπή πέσει μέσα σε ετικέτα,
     * γυρνάμε πίσω στο «<» ώστε να μη μείνει μισή ετικέτα στη σελίδα.
     */
    private truncate(message?: string): string | undefined {
        if (!message || message.length <= TOAST_MAX_LENGTH)
            return message;

        let text = message.substring(0, TOAST_MAX_LENGTH);

        const lastOpen = text.lastIndexOf('<');

        if (lastOpen > -1 && text.indexOf('>', lastOpen) === -1)
            text = text.substring(0, lastOpen);

        return `${text.trimEnd()}…`;
    }
}
